import api from './api';
import { Card, CreateCardDto } from '../types';

export interface GetCardsParams {
  page?: number;
  limit?: number;
  search?: string;
  maturityFilter?: 'all' | 'new' | 'upToDate' | 'due' | 'learning' | 'mature' | 'review';
  difficultyFilter?: 'all' | 'easy' | 'medium' | 'hard';
  tags?: string;
  sortBy?: 'date' | 'difficulty' | 'reviews' | 'accuracy' | 'next';
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedCardsResponse {
  cards: Card[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const cardService = {
  async getCards(deckId: string, params?: GetCardsParams): Promise<Card[] | PaginatedCardsResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.maturityFilter) queryParams.append('maturityFilter', params.maturityFilter);
    if (params?.difficultyFilter) queryParams.append('difficultyFilter', params.difficultyFilter);
    if (params?.tags) queryParams.append('tags', params.tags);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    
    const queryString = queryParams.toString();
    const url = `/decks/${deckId}/cards${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data;
  },

  async getCard(id: string): Promise<Card> {
    const response = await api.get(`/cards/${id}`);
    return response.data;
  },

  async createCard(deckId: string, cardData: CreateCardDto): Promise<Card> {
    const response = await api.post(`/decks/${deckId}/cards`, cardData);
    return response.data;
  },

  async updateCard(id: string, cardData: Partial<CreateCardDto>): Promise<Card> {
    const response = await api.patch(`/cards/${id}`, cardData);
    return response.data;
  },

  async deleteCard(id: string): Promise<void> {
    await api.delete(`/cards/${id}`);
  },

  async getCardStats(deckId: string): Promise<{
    totalCards: number;
    dueCards: number;
    newCards: number;
    upToDateCards: number;
    youngCards: number;
    matureCards: number;
    totalReviews: number;
  }> {
    const response = await api.get(`/decks/${deckId}/cards/stats`);
    return response.data;
  },

  async getNextReviewInfo(deckId: string): Promise<{
    nextReviewDate: string | null;
    cardsToReview: number;
  }> {
    const response = await api.get(`/decks/${deckId}/cards/next-review`);
    return response.data;
  },
};
